import { BypassCheck, Exemption, ExemptionDTO } from "./exemptions.types";

export const isBypassCheck = (value: string): value is BypassCheck =>
  [
    "antispoof",
    "spam",
    "frequently_exploited_domains",
    "graymail",
    "suspicious_intent",
    "phishing",
    "malware",
    "malicious_intent",
    "fraud",
  ].includes(value);

export const mapExemptionDTO = (dto: ExemptionDTO): Exemption => ({
  id: dto.id,
  address: dto.value,
  type: dto.type,
  skipped_checks: (dto.skipped_checks ?? []).filter(isBypassCheck),
  comment: dto.comment,
  inherited: Boolean(dto.inherited_from),
  updated_at: dto.updated_at,
  created_at: dto.created_at,
  modified_by: dto.modified_by,
  secondary_condition: dto.secondary_condition,
});

export const getEnabledChecks = (
  bypassChecks: Record<BypassCheck, boolean>,
): string[] =>
  Object.entries(bypassChecks).reduce<string[]>(
    (enabledChecks, [check, enabled]) =>
      enabled ? [...enabledChecks, check] : enabledChecks,
    [],
  );
